import styled from '@emotion/styled';

export const InformationHeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	color: var(--black);
	width: 100%;
`;

export const NotifyCell = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--margin-1);
`;

export const InstructionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.581rem;
	padding: 0 var(--padding-2);
`;

export const InstructionColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--margin-2);
	width: 100%;
`;

export const CourierNameContainer = styled.div`
	display: flex;
	align-items: center;
	overflow: auto;
	gap: 1rem;

	img {
		border-radius: 50%;
	}
`;

export const CourierScore = styled.div`
	display: flex;
	padding-top: var(--margin-1);
	gap: var(--margin-1);
`;

export const ScoreCardTooltip = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--margin-3);
`;

export const ScoreCardTooltipRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: var(--margin-3);
`;

export const CellContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const PickupDropoffCell = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.75rem;
`;
